import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Dashboard } from './pages/Dashboard';
import { CustomerList } from './pages/CustomerList';
import { CustomerDetail } from './pages/CustomerDetail';
import { EnquiryList } from './pages/EnquiryList';
import { EnquiryDetail } from './pages/EnquiryDetail';
import { TicketList } from './pages/TicketList';
import { TicketDetail } from './pages/TicketDetail';
import { UserManagement } from './pages/UserManagement';
import { BranchManagement } from './pages/BranchManagement';
import { ProfileSettings } from './pages/ProfileSettings';
import { MarketingLeadsList } from './pages/MarketingLeadsList';
import { MarketingLeadDetail } from './pages/MarketingLeadDetail';
import { MarketingReports } from './pages/MarketingReports';
import { BranchPerformance } from './pages/BranchPerformance';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/customers" element={<ProtectedRoute><CustomerList /></ProtectedRoute>} />
          <Route path="/customers/:id" element={<ProtectedRoute><CustomerDetail /></ProtectedRoute>} />
          <Route path="/enquiries" element={<ProtectedRoute><EnquiryList /></ProtectedRoute>} />
          <Route path="/enquiries/:id" element={<ProtectedRoute><EnquiryDetail /></ProtectedRoute>} />
          <Route path="/tickets" element={<ProtectedRoute><TicketList /></ProtectedRoute>} />
          <Route path="/tickets/:id" element={<ProtectedRoute><TicketDetail /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
          <Route path="/branches" element={<ProtectedRoute><BranchManagement /></ProtectedRoute>} />
          <Route path="/marketing-leads" element={<ProtectedRoute><MarketingLeadsList /></ProtectedRoute>} />
          <Route path="/marketing-leads/:id" element={<ProtectedRoute><MarketingLeadDetail /></ProtectedRoute>} />
          <Route path="/marketing-reports" element={<ProtectedRoute><MarketingReports /></ProtectedRoute>} />
          <Route path="/branch-performance" element={<ProtectedRoute><BranchPerformance /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfileSettings /></ProtectedRoute>} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;